export default __webpack_public_path__ + "static/Fly7-cb802ddd9766154aad852836cc7b25d0.mp3";